import { Box, Center } from '@chakra-ui/react';

const SurveyHeaderWrapper = ({children}) => {
    return (
      <Center
        height='fit-content'
        marginTop=".5rem"
        marginBottom="1rem"
        width="100vw"
        paddingLeft={['20px', '40px', '80px']}
        paddingRight={['20px', '40px', '80px']}
        borderBottom="1px"
        borderColor="GRAY"
      >
        <Box
          display="flex"
          width="100%"
          maxWidth="1400px"
          height="100%"
          flexDirection="row"
          justifyContent="flex-start"
          alignItems="center"
        >
          {children}
        </Box>
      </Center>
    );
};
export default SurveyHeaderWrapper;
